module.exports = __webpack_public_path__ + "static/media/blog.22838a8f.jpg";